import cx from 'classnames';
import React, { CSSProperties } from 'react';
import styles from './styles.scss';

interface Props {
  className?: string;
  isActive: boolean;
  onClick?: () => void;
  children: JSX.Element | (JSX.Element | false)[];
  position?: 'center';
  style?: CSSProperties;
  overlayBackground?: 'blurred' | 'transparent';
}

export default function Overlay(props: Props) {
  return (
    <>
      <div
        style={props.style}
        className={cx({
          [styles.focusArea]: props.isActive,
          [styles.center]: props.position === 'center',
        })}
      >
        {props.children}
      </div>
      {props.isActive && (
        <div
          onClick={props.onClick}
          className={cx(styles.overlay, props.className, {
            [styles.overlayTransparent]: props.overlayBackground === 'transparent',
          })}
        ></div>
      )}
    </>
  );
}
